<template>
    <div>
        <div class="grid grid-cols-4 gap-4" v-if="!loadingTodos">
            <div class="col-span-4 md:col-span-2">
                <label class="font-normal text-md">Type</label>
                <!-- todo add select for when there are more types in the future-->
                <!--<el-select v-model="form.type" class="w-full" placeholder="Select Type"-->
                <!--           :disabled="form.busy" @input="typeChangedEvent()"-->
                <!--           v-if="!mutableTodo">-->
                <!--    <el-option-->
                <!--        v-for="(type, index) in todoTypes"-->
                <!--        :key="index"-->
                <!--        :label="type | titlecase"-->
                <!--        :value="type"-->
                <!--    ></el-option>-->
                <!--</el-select>-->

                <div v-if="mutableTodo">{{ mutableTodo.type | titlecase }}</div>
                <div v-else>{{ form.type | titlecase }}</div>

                <span class="text-red-500 text-xs break-normal mt-1" :class="{'d-block': form.errors.has('type')}"
                      v-show="form.errors.has('type')">
                    {{ form.errors.get("type") }}
                </span>
            </div>

            <div class="col-span-4 md:col-span-2" v-if="form.type === 'schedule inspection'">
                <label class="font-normal text-md">Asset</label>
                <remote-select
                    v-if="!mutableTodo"
                    v-model="selectedAsset"
                    @focus="searchAssets"
                    :remote-method="searchAssets"
                    :loading="loadingTodos"
                    :data="assets"
                    @input="selectAsset()"
                    item-label="name"
                    placeholder="Start typing to search assets, addresses or linked contacts">
                    <template slot-scope="props">
                        <assets-drop-down-item :asset="props.item"></assets-drop-down-item>
                    </template>
                </remote-select>

                <div v-else> {{ mutableTodo.asset.name }}</div>

                <div class="text-red-500 text-xs break-normal mt-1" v-show="form.errors.has('asset_id')">
                    {{ form.errors.get("asset_id") }}
                </div>
            </div>

            <div class="col-span-4 md:col-span-2" v-if="form.type === 'review ticket'">
                <label class="font-normal text-md">Ticket</label>
                <remote-select
                    v-if="!mutableTodo && !ticket"
                    v-model="selectedTicket"
                    @focus="searchTickets"
                    :remote-method="searchTickets"
                    :loading="loadingTodos"
                    :data="tickets"
                    @input="selectTicket()"
                    item-label="ticket_reference_number"
                    placeholder="Start typing to search tickets or assets">
                    <template slot-scope="props">
                        <div class="flex flex-col py-3 leading-snug">
                            <div class="flex justify-between items center">
                                <span class="text-indigo-700 overflow-hidden truncate">{{ props.item.asset_name }}</span>

                                <span>{{ props.item.ticket_reference_number }}</span>
                            </div>

                            <span class="text-gray-400 text-sm">Logged {{ props.item.logged_at | date }}</span>
                        </div>
                    </template>
                </remote-select>

                <div v-else-if="mutableTodo && mutableTodo.ticket || ticket">
                    {{ ticketReference }}
                </div>

                <div class="text-red-500 text-xs break-normal mt-1" v-show="form.errors.has('model_id')">
                    {{ form.errors.get("model_id") }}
                </div>
            </div>

            <div class="col-span-4">
                <label class="font-normal text-md w-full">Description</label>
                <span class="w-full">{{ form.type ? form.description : "Select a type to generate a description" }}</span>
            </div>

            <div class="col-span-4">
                <label class="font-normal text-md">Reminder Date</label>
                <el-date-picker
                    :disabled="form.busy"
                    :picker-options="reminderDatePickerOptions"
                    class="w-full"
                    v-model="form.reminder_date"
                    placeholder="Pick A Day"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
                <span class="text-red-500 text-xs break-normal mt-1" v-show="form.errors.has('reminder_date')">
                    {{ form.errors.get("reminder_date") }}
                </span>
            </div>

            <div class="col-span-4 md:col-span-2">
                <label class="font-normal text-md">Repeat</label>
                <el-select class="w-full" v-model="form.repeat" placeholder="Recurring reminder" @input="setIntervalType()">
                    <el-option
                        v-for="value in repeatOptions"
                        :key="value"
                        :label="value | capitalize"
                        :value="value">
                    </el-option>
                </el-select>

                <span class="text-red-500 text-xs break-normal mt-1"
                      v-show="form.errors.has('repeat')">
                    {{ form.errors.get("repeat") }}
                </span>
            </div>

            <!-- Repeat Once - Reminder Date -->
            <div class="col-span-4 md:col-span-2" v-if="form.repeat === 'once'">
                <label class="font-normal text-md">Repeat Once On</label>
                <el-date-picker
                    class="w-full"
                    v-model="form.repeat_once_on"
                    type="date"
                    :picker-options="repeatDatePickerOptions"
                    placeholder="Pick a day"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
                <span class="text-red-500 text-xs break-normal mt-1"
                      v-show="form.errors.has('repeat_once_on')">
                    {{ form.errors.get("repeat_once_on") }}
                </span>
            </div>

            <!-- Repeat Periodically -->
            <div class="col-span-4 md:col-span-2" v-if="form.repeat === 'periodically'">
                <label class="font-normal text-md">Repeat Every</label>

                <div class="flex items-center space-x-2">
                    <!-- Interval amount -->
                    <text-input class="w-1/4" placeholder="X"
                                v-model="form.interval">

                    </text-input>

                    <!--Interval type-->
                    <el-select class="w-3/4" v-model="form.interval_type"
                               placeholder="Interval type">
                        <el-option
                            v-for="value in intervalOptions"
                            :key="value"
                            :label="value | capitalize"
                            :value="value">
                        </el-option>
                    </el-select>
                </div>

                <span class="text-red-500 text-xs break-normal mt-1"
                      v-show="form.errors.has('interval_type')">
                    {{ form.errors.get("interval_type") }}
                </span>
                <span class="text-red-500 text-xs break-normal mt-1"
                      v-show="form.errors.has('interval')">
                    {{ form.errors.get("interval") }}
                </span>
            </div>

            <div class="col-span-4">
                <label class="font-normal text-md">To-do Assigned To</label>
                <el-select v-model="form.user_ids" class="w-full"
                           @focus="fetchUsers($event.target.input, portfolioId, 1000)"
                           placeholder="Search and select users"
                           filterable
                           collapse-tags
                           multiple>
                    <el-option
                        v-for="user in users"
                        :key="user.id"
                        :label="user.name | capitalize"
                        :value="user.id">
                    </el-option>
                </el-select>

                <span class="text-red-500 text-xs break-normal mt-1"
                      v-show="form.errors.has('user_ids')">
                    {{ form.errors.get("user_ids") }}
                </span>
            </div>

            <div class="col-span-4">
                <div class="flex flex-wrap" :class="mutableTodo && !mutableTodo.archived_at ? 'justify-between' : 'justify-end'">
                    <button v-if="mutableTodo || (mutableTodo && !mutableTodo.archived_at)"
                            class="flex items-center gap-2 text-gray-400 hover:text-yellow-600 px-2 hover:bg-gray-100 rounded-md cursor-pointer transition duration-300"
                            @click="archiveTodo()">
                        <icon-archive-box class="w-4 h-4"></icon-archive-box>

                        <span class="text-sm">Archive</span>
                    </button>

                    <div class="flex items-center gap-2">
                        <model-replication-tooltip v-if="mutableTodo && mutableTodo.replication_details"
                                                   :replication-details="mutableTodo.replication_details"></model-replication-tooltip>

                        <secondary-button @click.prevent="createOrUpdateTodo()" :disabled="form.busy">
                            {{ createButtonText }}
                        </secondary-button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="loadingTodos" class="text-gray-500 flex justify-center items-center py-6 text-lg">
            <icon-refresh class="h-4 w-4 animate-spin text-indigo-600"/> &nbsp;Loading...
        </div>
    </div>
</template>

<script>
import AssetSearch from "../../mixins/asset-search";
import TicketSearch from "../../mixins/ticket-search";
import UsersSearch from "../../mixins/users-search";

export default {
    mixins: [AssetSearch, UsersSearch, TicketSearch],

    props: {
        ticket: {
            type: Object,
            required: false,
            description: "Used to populate the type of todo and also the todo reminder date if applicable"
        },
        todo: {
            type: Object,
            required: false,
            description: "This is the todo, if we have a todo as a prop, we are editing, otherwise create"
        },
        preSelectedAsset: {
            type: Object,
            required: false,
            description: "Allows us to preselect the asset for creating a todo"
        }
    },

    data () {
        return {
            loadingTodos: true,
            mutableTodo: this.todo,
            form: new AppForm({
                reminder_date: "",
                repeat: "",
                interval_type: "",
                interval: "",
                repeat_once_on: "",
                type: "",
                description: "",
                model_type: "",
                model_id: null,
                asset_id: null,
            }),
            selectedAsset: this.preSelectedAsset,
            selectedTicket: null,
            todoTypes: [],
            repeatOptions: ["never", "once", "periodically"],
            intervalOptions: ["days", "weeks", "months", "years"],
        };
    },

    computed: {
        portfolioId () {
            return this.mutableTodo && this.mutableTodo.asset && this.mutableTodo.asset.portfolio_id ? this.mutableTodo.asset.portfolio_id : null;
        },

        createButtonText () {
            if (this.mutableTodo) {
                if (this.form.busy) {
                    return "Updating To-do...";
                }
                return "Update To-do";
            }

            if (this.form.busy) {
                return "Creating To-do...";
            }
            return "Create To-do";
        },

        reminderDatePickerOptions () {
            let self = this;
            return {
                disabledDate (date) {
                    return date < self.$dayjs().subtract(1, "day");
                }
            };
        },

        repeatDatePickerOptions () {
            let self = this;
            return {
                disabledDate (date) {
                    if (self.form && self.form.reminder_date) {
                        return date < self.$dayjs(self.form.reminder_date).add(1, "day");
                    }
                    return date < self.$dayjs();
                }
            };
        },
        ticketReference () {
            if (this.mutableTodo && this.mutableTodo.ticket) {
                return this.mutableTodo.ticket.ticket_reference_number;
            } else if (this.ticket) {
                return this.ticket.ticket_reference_number;
            }
            return "";
        }
    },

    watch: {
        todo: {
            handler: function (newTodo) {
                this.mutableTodo = newTodo;
                this.setupUsersAndForm();
            },
            deep: true
        },

        ticket: {
            handler: function () {
                this.setupUsersAndForm();
            },
            deep: true
        },
        preSelectedAsset (newAsset) {
            this.selectAsset(newAsset);
        }
    },

    mounted () {
        // Init form after possibly setting mutableTodo from the ticket above
        this.setupUsersAndForm();

        let self = this;
        Bus.$on("update-users-list", function (response) {
            self.fetchUsers(null, self.portfolioId, 1000);
        });
    },

    methods: {
        setupUsersAndForm () {
            this.loadingTodos = true;

            this.fetchUsers(null, this.portfolioId, 1000)
            .then(() => this.initForm()
            .then(() => this.loadingTodos = false
            ));
        },

        initForm () {
            return new Promise((resolve, reject) => {
                this.selectedAsset = null;
                this.selectedTicket = null;

                //set todos model variables
                let id, type, description, model_type, model_id, asset_id = null;
                let userIds = [];
                if (this.mutableTodo) {
                    id = this.mutableTodo.id;
                    type = this.mutableTodo.type;
                    description = this.mutableTodo.description;
                    model_type = this.mutableTodo.model_type;
                    model_id = this.mutableTodo.model_id;
                    asset_id = this.mutableTodo.asset ? this.mutableTodo.asset.id : null;
                    this.selectedAsset = this.mutableTodo.asset ? {name: this.mutableTodo.asset.name, id: this.mutableTodo.asset.id} : null;
                    userIds = this.mutableTodo.users.map(function (user) {
                        return user.id;
                    });
                } else if (this.ticket) {
                    type = "review ticket";
                    description = "This ticket is due for a follow up";
                    model_type = "App\\Ticket";
                    model_id = this.ticket.id;
                    asset_id = this.ticket.asset_id;
                    this.selectedAsset = {name: this.ticket.asset.name, id: this.ticket.asset.id};
                    userIds.push(this.state.user.id);
                    if (this.ticket.assigned_to && !userIds.includes(this.ticket.assigned_to)) {
                        userIds.push(this.ticket.assigned_to);
                    }
                } else {
                    type = "schedule inspection";
                    description = "You need to schedule an inspection";
                    userIds.push(this.state.user.id);
                }

                // instantiate form
                this.form = new AppForm({
                    id: id ? id : null,
                    reminder_date: null,
                    repeat: "never",
                    interval_type: null,
                    interval: null,
                    repeat_once_on: null,
                    type: type ? type : null,
                    description: description ? description : null,
                    model_type: model_type ? model_type : null,
                    model_id: model_id ? model_id : null,
                    asset_id: asset_id ? asset_id : null,
                    user_ids: userIds ? userIds : [],
                });

                //set reminder from mutableTodo
                if (this.mutableTodo) {
                    // Use latest because we get information from ticket with no TodoResource
                    if (this.mutableTodo.latest_reminder) {
                        this.form.reminder_date = this.$dayjs(this.mutableTodo.latest_reminder.reminder_date).format("YYYY-MM-DD");
                        this.form.repeat = this.mutableTodo.latest_reminder.repeat;
                        this.form.interval_type = this.mutableTodo.latest_reminder.interval_type;
                        this.form.interval = this.mutableTodo.latest_reminder.interval;
                        if (this.form.repeat === "once") {
                            this.form.repeat_once_on = this.$dayjs(this.mutableTodo.latest_reminder.repeat_once_on).format("YYYY-MM-DD");
                        }
                    }
                }
                resolve();
            });
        },

        createOrUpdateTodo () {
            if (this.mutableTodo) {
                this.updateTodo();
            } else {
                this.createTodo();
            }
        },

        createTodo () {
            App.post("/todos/create", this.form)
            .then((response) => {
                this.$emit("todo-created", response);
                this.closeForm();
                toastr.success("Successfully Created To-do");
            })
            .catch(errors => {
                toastr.error(errors.message);
            });
        },

        updateTodo () {
            App.patch(`/todos/${this.mutableTodo.id}/update`, this.form)
            .then((response) => {
                this.$emit("todo-updated", response);
                this.closeForm();
                toastr.success("Successfully Updated To-do");
            })
            .catch(errors => {
                toastr.error(errors.message);
            });
        },

        archiveTodo () {
            App.patch(`/todos/${this.mutableTodo.id}/toggle-archived`, this.form)
            .then(() => {
                this.$emit("todo-updated", null);
                this.closeForm();
                toastr.success("Successfully Archived To-do");
            })
            .catch(errors => {
                toastr.error(errors.message);
            });
        },

        selectAsset (asset) {
            if (asset) {
                this.selectedAsset = asset;
            }
            this.form.asset_id = this.selectedAsset ? this.selectedAsset.id : null;
            this.setDescription();
        },

        selectTicket () {
            this.form.model_id = this.selectedTicket ? this.selectedTicket.id : null;
            this.form.model_type = "App\\Ticket";
            this.form.asset_id = this.selectedTicket ? this.selectedTicket.asset_id : null;
        },

        typeChangedEvent () {
            this.selectedAsset = null;
            this.selectedTicket = null;
            this.setDescription();
        },

        setDescription () {
            switch (this.form.type) {
                case("review ticket"):
                    this.form.description = "This ticket is due for a follow up";
                    break;
                case("schedule inspection"):
                    this.form.description = this.selectedAsset ?
                        "You need to schedule an inspection for " + this.selectedAsset.name :
                        "You need to schedule an inspection";
                    break;
                default:
                    this.form.description = "";
            }
        },

        setIntervalType () {
            if (this.form.repeat === "periodically") {
                this.form.interval_type = "days";
            } else {
                this.form.interval_type = null;
            }
            this.form.interval = null;
            this.form.repeat_once_on = null;
        },

        closeForm () {
            this.mutableTodo = null;
            this.setupUsersAndForm();
            this.$emit("close");
        },
    },
};
</script>
